import { OpenAPIV3 } from 'openapi-types';

export default function parseServerUrlDataForTableView(data: OpenAPIV3.ServerObject) {
  const { variables } = data;
  if (variables) {
    return {
      headers: ['Variable', 'Description', 'Default Value', 'Options'],
      rows: Object.keys(variables).map(key => {
        const variable = variables[key];
        return {
          name: key,
          description: variable?.description, // Use optional chaining and fallback
          defaultValue: variable?.default, // Use optional chaining and fallback
          options: variable?.enum && variable.enum.join(', '), // Safely handle undefined enum
        };
      }),
    };
  }
  return {
    headers: ['Variable', 'Description', 'Default Value', 'Options'],
    rows: [],
  };
}
